// extracted by mini-css-extract-plugin
module.exports = {"profileSelect":"DDuw0","noSkillsWrapper":"oANzg"};